import { css } from '@emotion/core';
import * as React from 'react';
import { Z_INDEX } from '../globalStyle/zIndex';
import { HIDE_ON_MOBILE } from '../globalStyle/mediaQueries';
import { IS_DEV_ENV } from '../core/windowProps';


const styles = {
  version: css`
    position: fixed;
    left: 10px;
    bottom: 10px;
    font-size: 16px;
    color: #777777;
    z-index: ${Z_INDEX.APP_VERSION};

    // Version isn't even in the designs, so we're just going to hide it on mobile to avoid render issues.
    ${HIDE_ON_MOBILE};
  `,
  hidden:  css`
    visibility: hidden;
  `,
};

type Props = {
  className?: string;
};

/**
 * AppVersion: a component that renders the app version from package.json at the bottom-left corner of the screen.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const AppVersion: React.FC<Props> = props => (
  <span title='App Version' css={[styles.version, props.className, !IS_DEV_ENV && styles.hidden]}>
    v{process.env.__VERSION__}
  </span>
);

export default AppVersion;
